import { useEffect, useState } from 'react'
import { useAlert } from 'react-alert'
import { fetchConstructor, fetchTest } from '../../../main/usecases'
import { saveTestXConstruct } from '../../../main/usecases/admin-menu/test-x-contruct'
import Button from '../button'
import SelectInput from '../select-input'

import * as S from './styles'

const RegisterModal = () => {
  const alert = useAlert()
  const [tests, setTests] = useState([])
  const [constructs, setConstructs] = useState([])
  const [test, setTest] = useState<string>('')
  const [construct, setConstruct] = useState<string>('')
  const [enable, setEnable] = useState(true)
  useEffect(() => {
    ;(async () => {
      const tests = await fetchTest().load()
      const constructs = await fetchConstructor().load()
      setTests(tests)
      setConstructs(constructs)
    })()
  }, [])
  useEffect(() => {
    test && construct !== '' ? setEnable(false) : setEnable(true)
  }, [construct, test])
  const handleSave = async () => {
    try {
      await saveTestXConstruct(test, construct).post('')
      window.location.reload()
      alert.show('Sucesso ao relacionar teste com construto', {
        type: 'success',
        timeout: 4000
      })
    } catch (error) {
      alert.show('Erro ao relacionar teste com construto', {
        type: 'error',
        timeout: 4000
      })
    }
  }
  return (
    <S.ModalInfo>
      <SelectInput
        labelColor="#4F4F4F"
        label="Teste*"
        name="test"
        wrapperClassName="modal-select"
        options={
          tests?.map((item: { cdTeste: number; nome: string }) => {
            return { value: item.cdTeste, label: item.nome }
          }) || []
        }
        onChange={(e) => setTest(e.target.value)}
      />
      <SelectInput
        labelColor="#4F4F4F"
        label="Construto*"
        name="construct"
        wrapperClassName="modal-select"
        options={
          constructs?.map(
            (item: {
              cdConstruto: number
              construto: string
              categoriaConstruto: string
            }) => {
              return { value: item.cdConstruto, label: item.construto }
            }
          ) || []
        }
        onChange={(e) => setConstruct(e.target.value)}
      />
      <Button onClick={handleSave} disabled={enable}>
        Salvar
      </Button>
    </S.ModalInfo>
  )
}

export default RegisterModal
